module.exports = __webpack_public_path__ + "img/leftColumn.42080df6.png";